// Firebase configuration - will work when Firebase is installed
// For now, using localStorage as fallback
interface FirebaseConfig {
  apiKey?: string;
  authDomain?: string;
  projectId?: string;
  storageBucket?: string;
  messagingSenderId?: string;
  appId?: string;
}

const firebaseConfig: FirebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

// Mock Firebase functions until Firebase is installed
export const mockDb = {
  collection: (name: string) => ({
    add: async (data: any) => {
      // Store in localStorage for now
      const reports = JSON.parse(localStorage.getItem('reports') || '[]');
      const newReport = {
        id: Date.now().toString(),
        ...data,
        timestamp: new Date().toISOString(),
        createdAt: new Date().toISOString(),
      };
      reports.push(newReport);
      localStorage.setItem('reports', JSON.stringify(reports));
      console.log('Report saved to localStorage:', newReport);
      return { id: newReport.id };
    },
    get: async () => {
      const reports = JSON.parse(localStorage.getItem('reports') || '[]');
      return { docs: reports.map((r: any) => ({ id: r.id, data: () => r })) };
    }
  })
};

export const db = mockDb;
export default firebaseConfig;